import Base from './base'

export default {
  get () {
    return Base
      .get('/webpromo/current')
      .then(res => res.data)
  }
}
